import './invitation-status-modal.scss';
import { DefaultModalLayout } from '../../../../components/modal/layouts/default-modal-layout';
import invitation_success from '../../../../images/invitation_success.svg';
import invitation_fail from '../../../../images/invitation_fail.svg';
import FontHeading4 from '../../../../components/fonts/font-heading4/font-heading4';
import { FONT_VARIANT } from '../../../../components/fonts/font-props';
import FontBody2 from '../../../../components/fonts/font-body2/font-body2';
import { Button } from '../../../../components/inputs/button/button';
import { BUTTON_VARIANTS } from '../../../../components/inputs/button-variants';

interface IProps {
    successful?: boolean;
    onClose: () => void;
}

const InvitationModal: React.FC<IProps> = ({ successful, onClose }) => {
    const src = successful ? invitation_success : invitation_fail;
    const title = successful ? 'Way to go!' : 'Oh No!';
    const message = successful
        ? 'Your invitation has been sent successfully!'
        : 'Your invitation has been not sent successfuly ';
    return <DefaultModalLayout isCloseDisabled={false} onCloseClicked={onClose}>
        <div className='invitation-modal-content'>
            <img src={src} alt="avatar" />
            <FontHeading4 variant={FONT_VARIANT.BOLD}>{title}</FontHeading4>
            <FontBody2>{message}</FontBody2>
            <div className="modal-footer">
                {successful ? (<Button
                    text="Got it!"
                    onClick={onClose}
                />) : <Button
                    variant={BUTTON_VARIANTS.Tertiary}
                    text="Go back"
                    onClick={onClose}
                />}
            </div>
        </div>
    </DefaultModalLayout>
};

export default InvitationModal;
